import { accordionAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { fontFamily } from '../font';
import colors from '../colors';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
    accordionAnatomy.keys
);

const baseStyle = definePartsStyle({
    button: {
        fontFamily: fontFamily,
        padding: '1rem 0'
    },
    container: {
        borderTop: 0,
        borderBottom: `1px solid ${colors.accent.main}`
    },
    panel: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingBottom: '3rem',
        color: colors.gray.main,
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem'
    }
});

export const Accordion = defineMultiStyleConfig({
    baseStyle
});
